export const walkScore = ['$http', function ($http) {
  return {
    link(scope, elem, attr) {
      $http({
        method: 'GET',
        url: '/wp-json/richman/v1/walkscore',
        params: {
          id: attr.walkScore
        }
      }).then(function successCallback(response) {
        scope.walkscoreData = JSON.parse(response.data)
        console.log(scope.walkscoreData)
      }, function errorCallback(response) {
        throw Error(response)
      });
    }
  }
}]